
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PageItemProps } from ".";
import { loading, create } from "store/page";
import { AppMessage } from "components";

interface ApiPageCreateInputProps extends Omit<PageItemProps, "id"> {
}

type ApiPageCreateOutputProps = OutputBaseProps<{ item: PageItemProps; }, ApiPageCreateInputProps>

export const apiPageCreate = async (data: ApiPageCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiPageCreateOutputProps>("/api/page/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};